import Vue from 'vue';
import chequeOrder from './cheque-order/cheque-order.vue';

Vue.component('cheque-order', chequeOrder);
